// extracted by css-extract-rspack-plugin
export default {"titleRow":"mIb90uYe07CKEqzk","title":"mgfEudLyqU2AmOOS","description":"EbblaVzaoNk2Q9c8"};